// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { BodyCopy, Heading } from '@tcp/core/styles/themes/TCP/typotheme';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import styles from '../../../styles/AddressBook.style';
import Row from '../../../../../../common/atoms/Row';
import Col from '../../../../../../common/atoms/Col';
import Button from '../../../../../../common/atoms/Button';
import AddressListComponent from '../../AddressList.view';
import EmptyAddressListComponent from '../../EmptyAddressList.view';
import DeleteAddressModal from '../../DeleteAddressModal.view';
import Notification from '../../../../../../common/molecules/Notification';
import utils from '../../../../../../../utils';
import AddressListComponentSkeleton from '../../../skeleton/AddressListComponentSkeleton.view';
import Anchor from '../../../../../../common/atoms/Anchor';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../../../utils/labels/globalActions.labels';
import AddressBookLabels, { ACCOUNT_LABELS } from '../../AddressBook.labels';

export class AddressView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedAddress: {},
    };
    this.accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AddressBookLabels);
    this.common = this.accountLabels.common;
    this.addressBook = this.accountLabels.addressBook;
  }

  setSelectedAddress = (address) => {
    this.setState({ selectedAddress: address });
  };

  onAddNNewAddressClick = () => {
    utils.routerPush(
      '/account?id=address-book&subSection=add-new-address',
      '/account/address-book/add-new-address'
    );
  };

  render() {
    const {
      addresses,
      labels,
      className,
      onDefaultShippingAddressClick,
      showUpdatedNotification,
      onDeleteAddress,
      deleteModalMountedState,
      setDeleteModalMountState,
      showUpdatedNotificationOnModal,
      isFetching,
      clearNotificationError,
      resetVerifyAddress,
      isInternationalPhoneNumberEnabled,
      newGlobalErrorMessageEnabled,
      isErrorModalVisibleState,
    } = this.props;
    const { selectedAddress } = this.state;
    const clickEventdata = {
      customEvents: [],
      eventName: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationName.address_addNew,
      pageNavigationText: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationText.address_addNew,
    };

    return (
      <div className={className}>
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              large: 12,
              medium: 8,
            }}
          >
            <BodyCopy component="div" className="elem-mb-MED account-dashboard-goback-link">
              <Anchor
                fontSizeVariation="xlarge"
                anchorVariation="secondary"
                to="/account?id=account-overview"
                asPath="/account"
              >
                <span className="left-arrow" />
                {renderLabel(
                  getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
                    GlobalActionsLabels
                  ),
                  'lbl_back'
                )}
              </Anchor>
            </BodyCopy>
            <Heading
              fontFamily="secondaryFontFamily"
              fontWeight="extrabold"
              HeadingLarge="six"
              tag="h2"
              className="addressBook__separator"
            >
              {renderLabel(
                this.addressBook?.ACC_LBL_ADDRESS_BOOK_HEADING,
                'ACC_LBL_ADDRESS_BOOK_HEADING'
              )}
            </Heading>
            {addresses?.size === 0 && <EmptyAddressListComponent labels={labels} />}
          </Col>
        </Row>

        <Row fullBleed className="addressBook__row--marginBottom">
          <Col
            colSize={{
              small: 6,
              large: 10,
              medium: 8,
            }}
            className="addressBook__addNewCtaContainer"
          >
            <ClickTracker clickData={clickEventdata}>
              <Button
                onClick={this.onAddNNewAddressClick}
                buttonVariation="variable-width"
                fill="BLUE"
                data-locator="addressbook-addnewaddress"
              >
                {renderLabel(
                  this.addressBook?.ACC_LBL_ADD_NEW_ADDRESS_CTA,
                  'ACC_LBL_ADD_NEW_ADDRESS_CTA'
                )}
              </Button>
            </ClickTracker>
          </Col>
        </Row>
        {showUpdatedNotification && !newGlobalErrorMessageEnabled && (
          <Notification
            status={showUpdatedNotification}
            colSize={{ large: 12, medium: 8, small: 6 }}
            message={
              showUpdatedNotification === 'success'
                ? renderLabel(this.common?.lbl_common_successMessage, 'lbl_common_successMessage')
                : renderLabel(this.common?.lbl_common_errorMessage, 'lbl_common_errorMessage')
            }
          />
        )}
        {isFetching && <AddressListComponentSkeleton />}
        {!isFetching && addresses?.size > 0 && (
          <AddressListComponent
            clearNotificationError={clearNotificationError}
            addresses={addresses}
            labels={labels}
            deleteModalMountedState={deleteModalMountedState}
            setSelectedAddress={this.setSelectedAddress}
            onDefaultShippingAddressClick={onDefaultShippingAddressClick}
            setDeleteModalMountState={setDeleteModalMountState}
            resetVerifyAddress={resetVerifyAddress}
            isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
            newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
          />
        )}
        <DeleteAddressModal
          clearNotificationError={clearNotificationError}
          openState={deleteModalMountedState}
          data={{
            heading: renderLabel(
              this.addressBook?.ACC_LBL_DELETE_ADDRESS_HEADING,
              'ACC_LBL_DELETE_ADDRESS_HEADING'
            ),
            title: renderLabel(
              this.addressBook?.ACC_LBL_DELETE_ADDRESS_TITLE,
              'ACC_LBL_DELETE_ADDRESS_TITLE'
            ),
            msg: renderLabel(
              this.addressBook?.lbl_deleteAddressModal_ccAssociatedAddressMsg,
              'lbl_deleteAddressModal_ccAssociatedAddressMsg'
            ),
            description: selectedAddress,
            buttons: {
              cancel: renderLabel(this.common?.lbl_common_dontDelete, 'lbl_common_dontDelete'),
              confirm: renderLabel(this.common?.lbl_common_YesDelete, 'lbl_common_YesDelete'),
            },
          }}
          setDeleteModalMountState={setDeleteModalMountState}
          labels={labels}
          onDeleteAddress={onDeleteAddress}
          showUpdatedNotificationOnModal={showUpdatedNotificationOnModal}
          isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
          newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
          isErrorModalVisibleState={isErrorModalVisibleState}
        />
      </div>
    );
  }
}
AddressView.defaultProps = {
  deleteModalMountedState: false,
  isFetching: false,
  resetVerifyAddress: () => {},
};

AddressView.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  className: PropTypes.string.isRequired,
  labels: PropTypes.shape({}).isRequired,
  onDefaultShippingAddressClick: PropTypes.shape({}).isRequired,
  showUpdatedNotification: PropTypes.string.isRequired,
  showUpdatedNotificationOnModal: PropTypes.string.isRequired,
  onDeleteAddress: PropTypes.func.isRequired,
  deleteModalMountedState: PropTypes.bool,
  setDeleteModalMountState: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  clearNotificationError: PropTypes.string.isRequired,
  resetVerifyAddress: PropTypes.func,
};
export default withStyles(AddressView, styles);
export { AddressView as AddressViewVanilla };
